import { Theme } from '@material-ui/core'
import { DEVICE_CATEGORIES_URL } from '../api-urls'
import { get, getByConditions } from '../common/fetch.utils'
import { filterParamsComposer } from '../common/get-by-conditions.utils'
import deviceCategoryfilterMapper from '../device-categories/device-category-filter.mapper'
import { DeviceCategoryDto } from '../dto/device-category/device-category.dto'
import { DeviceStatusCheck } from '../enum/DeviceStatusCheck'
import { DeviceTypes } from '../enum/DeviceTypes'
import { ResourceName } from '../ResourceName'

// Tree type filter for device categories
const getDeviceCategoryChildren = async (categoryId: number) => {
  let categoriesIds: number[] = []
  // eslint-disable-next-line no-await-in-loop
  const selectedCategory = await get<DeviceCategoryDto>(
    DEVICE_CATEGORIES_URL,
    `/${categoryId}`,
  )
  categoriesIds.push(selectedCategory?.id)
  let resolveParents = true
  while (resolveParents) {
    const parentCategoriesfilters = { parentIds: categoriesIds }
    // eslint-disable-next-line no-await-in-loop
    const childrenCategories = await getByConditions<DeviceCategoryDto>(
      `${DEVICE_CATEGORIES_URL}`,
      `o=>${filterParamsComposer(
        'o',
        parentCategoriesfilters,
        deviceCategoryfilterMapper,
      )}`,
    )
    const newChildren = childrenCategories
      .map((cc) => cc.id)
      // eslint-disable-next-line no-loop-func
      .filter((cc) => !categoriesIds.includes(cc))
    if (newChildren.length === 0) {
      resolveParents = false
    } else {
      categoriesIds = categoriesIds.concat(newChildren)
    }
  }
  return categoriesIds
}

const useColorPalette = (theme: Theme) => {
  const colorPalette = (deviceStatus: DeviceStatusCheck) => ({
    backgroundColor: theme.palette?.[deviceStatus]?.main,
    color: theme.palette?.[deviceStatus]?.contrastText,
  })

  return colorPalette
}

export const getDeviceShowLink = (
  deviceType: DeviceTypes,
  id: number | string,
): string => {
  switch (deviceType) {
    case DeviceTypes.BARRIERS:
      return `/${ResourceName.BARRIERS}/${id}/show`
    case DeviceTypes.CAMERA:
      return `/${ResourceName.CAMERAS}/${id}/show`
    case DeviceTypes.CAMERA_SERVER:
      return `/${ResourceName.CAMERA_SERVERS}/${id}/show`
    case DeviceTypes.DEPOSITOR:
      return `/${ResourceName.DEPOSITORS}/${id}/show`
    case DeviceTypes.DETECTOR:
      return `/${ResourceName.DETECTORS}/${id}/show`
    case DeviceTypes.DOORS:
      return `/${ResourceName.DOORS}/${id}/show`
    case DeviceTypes.ENGINE:
      return `/${ResourceName.ENGINES}/${id}/show`
    case DeviceTypes.IKSORIS_PARKING_TICKET_CASH_MACHINE:
      return `/${ResourceName.IKSORIS_PARKING_TICKET_CASH_MACHINES}/${id}/show`
    case DeviceTypes.IKSORIS_PARKING_TICKET_CASHLESS_MACHINE:
      return `/${ResourceName.IKSORIS_PARKING_TICKET_CASHLESS_MACHINES}/${id}/show`
    case DeviceTypes.OFFLINE_SERVER:
      return `/${ResourceName.OFFLINE_SERVERS}/${id}/show`
    case DeviceTypes.PALM:
      return `/${ResourceName.PALMS}/${id}/show`
    case DeviceTypes.PASSAGE:
      return `/${ResourceName.PASSAGES}/${id}/show`
    case DeviceTypes.SELFPOS_ACCESS_TICKET_CASHLESS_MACHINE:
      return `/${ResourceName.SELFPOS_ACCESS_TICKET_CASHLESS_MACHINES}/${id}/show`
    case DeviceTypes.TERMINALS:
      return `/${ResourceName.TERMINALS}/${id}/show`
    default:
      return ''
  }
}

export { getDeviceCategoryChildren, useColorPalette }
